import { useIntl } from 'react-intl'

const useIntlShort = () => {
  const intl = useIntl()

  return (id: string, params?: {[key: string]: any}) => id !== '' ? intl.formatMessage({ id }, params) : ''
}

export default useIntlShort
